<template>
  <div v-show="menuActive" class="action-menu">
    <div class="menu-backdrop" @click="closeMenu"></div>
    <div class="menu" ref="menu" @click="closeMenu">
      <button @click="schedule(today)">
        <div class="icon md-icon">today</div>
        <span>Dzisiaj</span>
      </button>
      <button @click="schedule(tomorrow)">
        <div class="icon md-icon">event</div>
        <span>Jutro</span>
      </button>
      <button @click="schedule(thisWeek)">
        <div class="icon md-icon">date_range</div>
        <span>Kiedyś w tym tygodniu</span>
      </button>
      <button @click="schedule(nextWeek)">
        <div class="icon md-icon">date_range</div>
        <span>Kiedyś w przyszłym tygodniu</span>
      </button>
      <button v-for="period in periods" :key="period._id" @click="schedule(period._id)">
        <div class="icon md-icon">calendar_today</div>
        <span>{{ period.name }}</span>
      </button>
      <button @click="unschedule()">
        <div class="icon md-icon">event_busy</div>
        <span>Bez daty</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: var(--bg-color-hover);
}
.menu {
  z-index: 15;
  position: fixed;
  border-radius: var(--rounding-smaller);
  background-color: var(--bg-color-card-default);
  border: var(--menu-border);
  display: flex;
  flex-flow: column nowrap;
  max-height: 90vh;
  overflow-y: auto;
}
.icon {
  flex: var(--indent-size) 0 0;
  margin: 0;
}
button {
  min-height: var(--indent-size);
  min-width: 150px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
button:hover {
  background: var(--bg-color-hover);
}
.menu span {
  text-align: left;
}
</style>

<script>
import selection from "../selection";
import { toMomentJSUnit } from "@/time-utils";
import { Item } from "../item";
import moment from "moment";
import { getItem } from "@/reactive-cache";
import { REL_PLAN } from "@/structure";

export default {
  data() {
    return {
      menuActive: false,
      triggerEl: null,
      item: new Item({}, this.$reactiveCache, this.$defaultDB),
    };
  },
  computed: {
    today() {
      return "day:" + moment().format("Y-MM-DD");
    },
    tomorrow() {
      const date = moment().add(1, "day");
      return "day:" + date.format("Y-MM-DD");
    },
    thisWeek() {
      const date = moment().startOf(toMomentJSUnit("week"));
      return "week:" + date.format("Y-MM-DD");
    },
    nextWeek() {
      const date = moment().startOf(toMomentJSUnit("week")).add(1, "week");
      return "week:" + date.format("Y-MM-DD");
    },
    periods() {
      return getItem("root:period").getChildren();
    },
  },
  methods: {
    schedule(target) {
      if (selection.length) {
        const dateItem = getItem(target);
        selection.appendTo(dateItem);
      } else {
        this.item.schedule(target);
      }
    },
    unschedule() {
      if (selection.length) {
        selection.clearParents(REL_PLAN)
      } else {
        this.item.unschedule();
      }
    },
    openMenu() {
      this.menuActive = true;
      this.$nextTick(() => {
        // we need the size for calculations, so it has to render first
        this.setMenuPosition(this.$refs.menu);
      });
    },
    setMenuPosition(menu) {
      const viewport = document.getElementById("toplevel").getBoundingClientRect();

      const width = menu.offsetWidth;
      if (viewport.width > this.triggerEl.left + width) {
        menu.style.left = this.triggerEl.left + "px";
        menu.style.right = "auto";
      } else if (this.triggerEl.right > width) {
        menu.style.right = viewport.width - this.triggerEl.right + "px";
        menu.style.left = "auto";
      } else {
        menu.style.left = "5vw";
        menu.style.right = "auto";
      }

      const height = menu.offsetHeight;
      if (viewport.height > this.triggerEl.top + height) {
        menu.style.top = this.triggerEl.top + "px";
        menu.style.bottom = "auto";
      } else if (this.triggerEl.bottom > height) {
        menu.style.bottom = viewport.height - this.triggerEl.bottom + "px";
        menu.style.top = "auto";
      } else {
        menu.style.bottom = "5vh";
        menu.style.top = "auto";
      }
    },
    closeMenu() {
      this.menuActive = false;
    },
  },
  mounted() {
    this.$root.$on("date-menu", (data) => {
      this.triggerEl = data.button;
      this.item = data.item;
      this.openMenu();
    });
  },
};
</script>
